export default {
  meta: {
    title: $localize`:@@meta.double.home.title:CS2 Double | (CS:GO) Дабл`,
    description: $localize`:@@meta.double.home.desc:CS2 Double CSFAIL - Играйте в рулетку КСГО Дабл и удваивайте свои выигрыши. Ощутите азарт и выигрывайте крупные призы на CSFAIL!`
  }
};